<!--设备数据-->
<template>
  <div>
    <!-- <img src="../../../../equipmentimg/topborder.png" class="topborder-box">
    <img src="../../../../equipmentimg/bottomborder.png" class="bottomborder-box"> -->
    <div class="data-text"  style="top: 85px;">运行时长</div>
    <div class="hidden"></div>
    <div class="hidden1"></div>
    <div class="all-left-top-box" style="width: 104%;margin-top: -105px;">
      <div class = "e-title-box">
        当前数据时间: {{this.deviceData.proDataTime}}
      </div>

      <div style="background-color:#0A2D57;width:94%;padding-top:20px;height:auto">

        <div class="border-x">
          <img src="../../../../equipmentimg/topborder.png" class="topborder-box">


          <a-row  :gutter="[10,8]" style="margin-left:15px;margin-top:20px;width:100%;">

            <a-col :span="6" v-for="item in deviceData.propertiesW" :key="item.ID" style="margin:3px -2px">
              <div class="e-card-single-box i">
                <img :src="item.cIcon" alt="" class="e-img-wh">
                <div class="e-card-text-box">
                  <div style="width: 150px;    overflow: hidden;">{{item.name}}</div>
                  <div>
                   总工时： {{item.TotalDuration}}分钟
                  </div>
                </div>
              </div>

            </a-col>

            <a-col :offset="23" :span="1" ><a-button @click="more" class="morebox" type="link">更多</a-button></a-col>
          </a-row>
        </div>
        <img src="../../../../equipmentimg/bottomborder.png" class="bottomborder-box">
      </div>
    </div>

    <a-card class="all-card-style " style="'background:#001528">
      <!--筛选条件-->
      <div class="search-box">
        <a-form layout="inline" :form="form" @submit="">

          <a-form-item
            label="展现形式" class="ant-form-item2"
          >
            <a-button-group>
              <a-button @click="showLine">曲线</a-button>
              <a-button @click="showTable">表格</a-button>
            </a-button-group>
          </a-form-item>

          <a-form-item
            label="起止日期" class="ant-form-item2"
          >
            <a-range-picker
              :default-value="[deviceData.queryInfoList.startDate, deviceData.queryInfoList.endDate]"
              @change="dateSelect"
            />
          </a-form-item>

          <a-form-item>
            <a-select :value="proSelectItem.value" style="width: 120px" @change="proSelect" class="ant-form-item2">
              <!-- <a-select-option value="1">
                全部
              </a-select-option>
              <a-select-option value="2">
                溶解氧
              </a-select-option>
              <a-select-option value="3">
                PH值
              </a-select-option>
              <a-select-option value="4">
                水温
              </a-select-option>
              <a-select-option value="5">
                压力
              </a-select-option> -->
              <a-select-option v-for="(item,index) in proSelectItems" :key="item.key" :value="index">
                {{item.value}}
              </a-select-option>

            </a-select>
          </a-form-item>

          <a-form-item>
            <a-select default-value="实时曲线" class="ant-form-item2"  style="width: 120px" >
              <a-select-option value="1">
                实时曲线
              </a-select-option>
              <!-- <a-select-option value="2">
                历史曲线
              </a-select-option> -->
              <a-select-option value="3">
                早均线
              </a-select-option>
              <a-select-option value="4">
                晚均线
              </a-select-option>
              <a-select-option value="5">
                日均线
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" html-type="button" @click="search">
              查询
            </a-button>
            <span class="button-margin"></span>
            <a-button html-type="submit" >
              导出
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--曲线-->
      <div  v-show="lineVisible">
        <div id="c1"></div>
      </div>

      <!--    表格-->
      <div v-if="tableVisible">
        <a-table :columns="columns" :data-source="deviceData.dataList"></a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { Chart } from '@antv/g2';
  import { _getDevicePropData,_getDevicePropDataTop } from '@/common/request.js'

  const columns = [

    {
      title: '时间',
      dataIndex: 'time2',
      key: 'time2',
    },
    {
      title: '原始值',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const data = [
    {
      key: '1',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '2',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
    {
      key: '3',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '4',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },

    {
      key: '5',
      num:'TradeCode21',
      name:'溶解氧传感器',
      time1:'95.55',
      time2:'95.55',
      time3:'95.55',
      time4:'95.55',
    },
  ];

  const data2 = [
    { year: '1991', value: 3 },
    { year: '1992', value: 4 },
    { year: '1993', value: 3.5 },
    { year: '1994', value: 5 },
    { year: '1995', value: 4.9 },
    { year: '1996', value: 6 },
    { year: '1997', value: 7 },
    { year: '1998', value: 9 },
    { year: '1999', value: 13 },
  ];

  export default {
    name: 'equipmentDataList',
    components: {

    },
    data() {
      return {
        form: this.$form.createForm(this),
        lineVisible:true,
        tableVisible:false,
        columns,
        data,
        data2,
        chart: {},
        proSelectItems:[],
        proSelectItem:{
          key:"",
          value:""
        },
        deviceData:{
          queryInfo:{
            productkey:"",
            devicename:"",
            limit:1
          },
          queryInfoList:{
            productkey:"",
            devicename:"",
            identifier:"",
            startDate:'2020-10-01',
            endDate:'2020-10-30',
            page:0,
            limit:0
          },
          devices:{},
          proDataTime:"",
          propertiesW:[],
          dataList:[],
          timer: '',//定时器
          timerList:''
        },
        setDeviceProParam:{
          productKey:"",
          devicename:"",
          IotId:"",
          inputParam:{}
        },
        spinning:false
      }
    },
    created(){

    },
    mounted() {

      this.createLine()
    //  this.deviceData.timer = setInterval(this.getDevicePropData, 10000);//定时10秒
    //  this.deviceData.timerList = setInterval(this.getDevicePropListData, 10000);//定时10秒

      this.  init1();
    },
    methods:{
      async init1(){
        let that=this;
        this.deviceData.queryInfoList.startDate=this.utils.getDate()
        this.deviceData.queryInfoList.endDate=this.utils.getDate('nextday')
        this.IotId=this.$route.query.IotId
        this.deviceData.queryInfoList.startDate=this.utils.getDate()
        this.deviceData.queryInfoList.endDate=this.utils.getDate('nextday')



        let res = await this.$http.post('WLWDevice/List', {
          sceneId: that.$store.getters.SCene.ID  ,
          cEntID:that.$store.getters.User.enterprise.ID,
          cSystemCode:'节水灌溉'
        })
        var device=res.data.obj.list;
        console.log('res.data.obj.list',res.data.obj.list);
        console.log('this.IotId)',this.IotId);
        device=device.filter(x=>x.IotId==this.IotId)[0]
        if(device!=null) this.deviceData.devices=device
      //  console.log('this.$store.getters.ThingModels',this.$store.getters.ThingModels);
      //  console.log('this.deviceData.devices.ProductKey',this.deviceData.devices.ProductKey);
        var ThingModel=this.$store.getters.ThingModels.filter(x=>x.productKey==this.deviceData.devices.ProductKey)[0]

        if(ThingModel!=null) {
       for(let t in ThingModel.propertiesW)   {
let productKey=ThingModel.propertiesW[t].productKey;
         let iotId=ThingModel.propertiesW[t].iotId;
         let   identifier =ThingModel.propertiesW[t].identifier;
         console.log(productKey,iotId,identifier);
let totlaRes=await this.$http.post('WLWDevice/TotalDuration',{productKey:productKey,iotId:iotId,identifier:identifier});
         ThingModel.propertiesW[t].TotalDuration=totlaRes.data.obj;
       }
        }




console.log('ThingModel12333333',ThingModel);
        if(ThingModel!=null) {
          this.deviceData.propertiesW=this.utils.deepClone(ThingModel.propertiesW)
          this.deviceData.propertiesW.forEach(element=>{
            var item={
              key:element.identifier,
              value:element.name
            }
            this.proSelectItems.push(item)
          })
          if(this.proSelectItems.length>0) {
            this.proSelectItem=this.proSelectItems[0]
            this.deviceData.queryInfoList.identifier=this.proSelectItem.key
          }
        }

        this.deviceData.queryInfo.productkey=this.deviceData.devices.ProductKey
        this.deviceData.queryInfo.devicename=this.deviceData.devices.DeviceName
        this.deviceData.queryInfoList.productkey=this.deviceData.devices.ProductKey
        this.deviceData.queryInfoList.devicename=this.deviceData.devices.DeviceName

        this.setDeviceProParam.productKey=this.deviceData.devices.ProductKey
        this.setDeviceProParam.devicename=this.deviceData.devices.DeviceName
        this.setDeviceProParam.IotId=this.IotId

        this.getDevicePropData()
        this.getDevicePropListData()

      },
      showLine:function(){
        this.lineVisible=true;
        this.tableVisible=false;
        // this.reloadDrawing()

      },
      showTable:function () {
        // this.reloadDrawing();

        this.lineVisible=false;
        this.tableVisible=true;

      },
      createLine:function(){
        // Step 1: 创建 Chart 对象
        this.chart = new Chart({
          container: 'c1',
          autoFit: true,
          width: 800,
          height: 500,
          padding:[30, 100, 30, 40],
        });

        // Step 2: 载入数据源
        //this.chart.data(data2);
        this.chart.data(this.deviceData.dataList);

        // Step 3：创建图形语法，绘制柱状图
        // this.chart.interval().position('genre*sold');
        this.chart.scale({
          // year: {
          //   range: [0, 1],
          // },
          // value: {
          //   min: 0,
          //   nice: true,
          // },
          time: {
        //    range: [0.05, 0.9],
        type: 'time',
       mask: 'YYYY-MM-DD HH:mm:ss',
          },
          value: {
            // min: min,
            // max:max,
            // tickInterval: step,
            nice: true
          }
        });
        this.chart.tooltip({
          showCrosshairs: true, // 展示 Tooltip 辅助线
          shared: true,
        });
        // this.chart.line().position('year*value').label('value');
        // this.chart.point().position('year*value');
        this.chart.line().position('time*value').label('value');

        // Step 4: 渲染图表
        this.chart.render();
      },

      reloadDrawing:function() {
        //销毁画布对象
        this.chart.destroy();
        //重新调用数据进行加载
        this.createLine();
      },
      async getDevicePropData(){
        console.log(this.deviceData.queryInfo)
        var res =await _getDevicePropData(this,this.deviceData.queryInfo)
        console.log(res)
        if(res !=null ){
          var data=res.obj.list
          if(data!=null && data.length>0)
          {
            this.deviceData.proDataTime=data[0].gmtCreateDes
            var dataItems=data[0].dataItems
            this.deviceData.propertiesW.forEach(element => {
              let src='';
              if (element.cIcon){
                src=element.cIcon;
              }else {
                src="../../../../img/kzhiyang.png"
              }
              element.cIcon=src;
              if(dataItems[element.identifier]){

                var value=this.utils.formatPropData(element,dataItems[element.identifier].value,false)
                this.$set(element,"dataValue",value)
              }
              else{
                this.$set(element,"dataValue",0)
              }
            })
          }
          else{
            this.deviceData.propertiesW.forEach(element => {
              this.$set(element,"dataValue",0)
            })
          }
        }
        else{
          this.$message.error(res.message);
        }
      },
      async getDevicePropListData(){


        let res=await this.$http.post('/WLWDevice/DevicePropertyDataList2',this.deviceData.queryInfoList);

console.log('res  get day ssssdatet :::',res);
        if(res !=null ) {
          this.deviceData.dataList = res.data.obj.list
          //销毁画布对象
          this.chart.destroy();
          //重新调用数据进行加载
          this.createLine();
          console.log('this.deviceData.dataList ',this.deviceData.dataList );
        }
        /*return;
        var res=await _getDevicePropData(this,this.deviceData.queryInfoList)
        if(res !=null ){
          var data=res.obj.list
          if(data!=null && data.length>0)
          {
            this.deviceData.dataList.splice(0)
            data.forEach(element => {
              if (element.dataItems[this.deviceData.queryInfoList.identifier]){
                var item={
                  time:element.gmtCreateDes,

                  value:this.utils.formatNumber1(element.dataItems[this.deviceData.queryInfoList.identifier].value)
                }
                this.deviceData.dataList.push(item)
              }

            })
            this.chart.render();
          }
          else{

          }
        }
        else{
          this.$message.error(res.message);
        }*/
      },
      dateSelect(date, dateString){
        this.deviceData.queryInfoList.startDate=dateString[0]
        this.deviceData.queryInfoList.endDate=dateString[1]
      },
      proSelect(value,opt){
        this.proSelectItem=this.proSelectItems[value]
      },
      search(){

        this.deviceData.queryInfoList.identifier=this.proSelectItem.key
        this.getDevicePropListData()
      },
      async deviceControl(checked,item){
        var param='"'+item.identifier+'":'+(checked?'1':'0')
        this.setDeviceProParam.inputParam='{'+param+'}'

        this.spinning=true
        const {data:res} = await this.$http.post('WLWDevice/SetDeviceProperty',this.setDeviceProParam)
        if(res.code=="200"){
          this.resetTimer()
          this.$message.success(res.message)
          item.dataValue=checked?'1':'0'
        }
        else{
          this.$message.error(res.message)
        }
        this.spinning=false
      },
      resetTimer(){
       // clearInterval(this.deviceData.timer)
       // this.deviceData.timer = setInterval(this.getDevicePropData, 10000);//定时10秒
      }
    },
    beforeDestroy(){
    //  clearInterval(this.deviceData.timer)
    //  clearInterval(this.deviceData.timerList)
    }
  }
</script>


<style>
  /* @import "../equipmentDetailsStyle.css"; */
  .all-card-style{
    background-color: #002140;
    margin-top: 30px !important;
    width: 97% !important;
  }
  .topborder-box{
    width: 100.8%;
    margin-left: -0.3%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    margin-top: 0%;
  }
  .bottomborder-box{
    width: 98%;
    margin-left: 1%;
    margin-bottom: 2%;
  }
  .i{
    height: 150px;
    width: 96%;
    border: 1px solid #1F608A;
    justify-content: center;
    align-items: center;
  }
  .vurve-box{
    width: 96%;
  }
  .vurve-box{
    margin-left: 20px;
    margin-top: 20px;
  }
  .data-text{
    position: relative;
    top: 80px;
    left: 48%;
    font-size: 160%;
  }
  .e-img-wh{
    width: 70px !important;
    height: 70px !important;
  }
  .e-card-text-big{
    font-size: 120% !important;
    margin-top: 20px;
  }
  .e-card-text-unit{
    font-size: 100%;
    margin-left: 5px;
    color: #637188;
  }
  .e-card-text-box{
    display: flex;
    flex-direction: column;
    height: 70px;
    justify-content: space-between;
  }
  .morebox {
    background: none!important;
    border: none!important;
  }
  .border-x{
    width: 97%;
    height: 500px;
    margin-left: 1.5%;
    height: auto;
    border-left: 1px solid #1F608A;
    border-right: 1px solid #1F608A;
    border-bottom: none;
    border-top: none;
  }
  /* .hidden{
    border: 1px solid #0A2D57;
    height: 34px;
    position: absolute;
    top: 30%;
    left: 7.5%;
  } */
  .hidden {

    height: 33px;
    position: relative;
    top: 39px;
    left: 2.4%;
    width: 8px;
    background: #0A2D57;
  }
  .hidden1 {

    height: 34px;
    position: relative;
    top: 8px;
    left: 97.2%;
    width: 8px;
    background:#0A2D57;
  }
  .shut-img{
    height: 20px;
    width: 60px;
  }
</style>


